module.exports = __webpack_public_path__ + "static/media/order_icon17.f90e1460.png";